import { TermSection } from '@qv-term/enums';

export const termVisibilityMenuItems = {
  [TermSection.REBATE]: 'Rebate',
  [TermSection.UM]: 'Utilization Management',
  [TermSection.SCENARIO]: 'Scenario Terms',
  [TermSection.PRICE_PROTECTION]: 'Price Protection',
  [TermSection.MARKET_SHARE]: 'Market Share',
};
